export default "__VITE_ASSET__eqC$QUeC__"